import { Component } from '@angular/core';

@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrl: './promotion.component.scss',
    standalone: false
})
export class PromotionComponent {

}
